import { useEffect, useRef } from "react";

const UrlListenerComponent = ({ onUrlChange}) => {
  const currentUrl = useRef(window.location.href);

  useEffect(() => {
    const checkUrl = () => {
      if (window.location.href !== currentUrl.current) {
        currentUrl.current = window.location.href;
        onUrlChange(currentUrl.current);
      }
    };
    checkUrl()
  }, [onUrlChange, window.location.href]);

  return null;
};

export default UrlListenerComponent;



// WEBPACK FOOTER //
// ./src/app/components/UrlListenerComponent/index.js